import { ANALYTICS_EVENT_NAMES } from "analytics/catalog/events";
import { buildCommonEventProps } from "analytics/core/commonProps";
import { trackEvent } from "analytics/core/tracker";

export type BillingAnalyticsContext = {
  pathname: string;
  search: string;
  businessId?: string | null;
  userId?: string | null;
  userEmail?: string | null;
  planType?: string | null;
  currency?: string | null;
};

const buildUpgradeModalProps = (
  context: BillingAnalyticsContext,
): Record<string, unknown> => {
  return buildCommonEventProps({
    screenKey: "upgrade_modal",
    pathname: context.pathname,
    search: context.search,
    businessId: context.businessId ?? null,
    userId: context.userId ?? null,
    userEmail: context.userEmail ?? null,
    planType: context.planType ?? null,
    currency: context.currency ?? null,
  });
};

const buildCheckoutProps = (
  context: BillingAnalyticsContext,
): Record<string, unknown> => {
  return buildCommonEventProps({
    screenKey: "checkout",
    pathname: context.pathname,
    search: context.search,
    businessId: context.businessId ?? null,
    userId: context.userId ?? null,
    userEmail: context.userEmail ?? null,
    planType: context.planType ?? null,
    currency: context.currency ?? null,
  });
};

export const trackUpgradeModalViewed = (
  context: BillingAnalyticsContext,
): void => {
  trackEvent(ANALYTICS_EVENT_NAMES.upgradeModalViewed, buildUpgradeModalProps(context));
};

export const trackUpgradeModalSubscribeClicked = (
  context: BillingAnalyticsContext,
): void => {
  trackEvent(
    ANALYTICS_EVENT_NAMES.upgradeModalSubscribeClicked,
    buildUpgradeModalProps(context),
  );
};

export const trackCheckoutPageViewed = (
  context: BillingAnalyticsContext,
): void => {
  trackEvent(ANALYTICS_EVENT_NAMES.checkoutPageViewed, buildCheckoutProps(context));
};

export const trackCheckoutSuccess = (
  context: BillingAnalyticsContext,
): void => {
  trackEvent(ANALYTICS_EVENT_NAMES.checkoutSuccess, buildCheckoutProps(context));
};
